import React from 'react';
import { EmptyState as CommonEmptyState } from '../../ui/common';

interface EmptyStateProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  actionButton?: React.ReactNode;
  className?: string;
}

/**
 * EmptyState - Reusable empty state component
 * 
 * Displays when no data is available with appropriate messaging,
 * icon, and optional action button for user guidance.
 */
const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  actionButton,
  className = ''
}) => {
  return (
    <CommonEmptyState
      icon={icon}
      title={title}
      description={description}
      actionButton={actionButton}
      className={className}
    />
  );
};

export default EmptyState;
